<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style>
* {
  box-sizing: border-box;
}

body {
  margin: 0;
}

.button-default {
  background-color: #000000; /* Green */
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  /* font-weight: bold; */
  max-width: 100%;
  max-height: 100px;
  text-transform: uppercase;
  font-weight: 600;
}

#app {
  font-family:'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
  overflow: hidden;
}

.modal {
  position: absolute;
  top: 5%;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-height: 90%;
  max-width: 700px;
  padding: 15px;
  overflow: auto;
  z-index : 3;
  background-color: white;
}

</style>

<script>


// import Home from '@/views/Home.vue'
export default {
  name : 'App',
  components : {
  }
}
</script>
